import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getOpenMarketProductsMeta,
  IGetOpenMarketProductsMetaParams,
  IGetOpenMarketProductsMetaReturn,
} from '../../../../api/product/queries/getOpenMarketProductsMeta';

interface IUseGetOpenMarketProductsMetaQueryParams {
  searchParam: IGetOpenMarketProductsMetaParams;
  options?: UseQueryOptions<IGetOpenMarketProductsMetaReturn, AxiosError>;
}

export const useGetOpenMarketProductsMetaQuery = ({
  searchParam,
  options,
}: IUseGetOpenMarketProductsMetaQueryParams) => {
  return useQuery<IGetOpenMarketProductsMetaReturn, AxiosError>(
    [
      'user-sell-tractors',
      `status=${searchParam?.status}`,
      `count=${searchParam?.count}`,
      `machineType=${searchParam?.machineType}`,
      `machineId=${searchParam?.machineId}`,
      `brand=${searchParam?.brand}`,
      `minEngineOutputPs=${searchParam?.minEngineOutputPs}`,
      `maxEngineOutputPs=${searchParam?.maxEngineOutputPs}`,
      `minPrice=${searchParam?.minPrice}`,
      `maxPrice=${searchParam?.maxPrice}`,
      `sort=${searchParam?.sort}`,
      `rowConfig=${searchParam?.rowConfig}`,
      `minOperationTime=${searchParam?.minOperationTime}`,
      `maxOperationTime=${searchParam?.maxOperationTime}`,
      `minManufacturedYear=${searchParam?.minManufacturedYear}`,
      `maxManufacturedYear=${searchParam?.maxManufacturedYear}`,
      `recentDays=${searchParam?.recentDays}`,
      `region=${searchParam?.region}`,
    ],
    () =>
      getOpenMarketProductsMeta({
        searchParam: {
          ...searchParam,
          machineType: searchParam?.machineType === 'ALL' ? '' : searchParam?.machineType,
          status: searchParam?.status === 'ALL' ? '' : searchParam?.status,
        },
      }),
    options,
  );
};
